module.exports = __webpack_public_path__ + "static/media/splitBean.19bd0804.png";